// extracted by mini-css-extract-plugin
export var shake = "_10-0";